import JsonLd from './JsonLd';

const localBusinessData = {
  '@context': 'https://schema.org',
  '@type': 'AutoRepair',
  name: 'Mécanique Auto CJPA',
  image: 'https://www.mecaniqueautocjpa.com/logo.webp',
  url: 'https://www.mecaniqueautocjpa.com',
  telephone: ['+15143272107', '+15145827527'],
  email: 'info@mecanique-cjpa.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '10011 Av. de Rome',
    addressLocality: 'Montréal-Nord',
    addressRegion: 'QC',
    postalCode: 'H1H 4N3',
    addressCountry: 'CA'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 45.6066,
    longitude: -73.6345
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00'
    }
  ],
  priceRange: '$$',
  currenciesAccepted: 'CAD',
  paymentAccepted: 'Cash, Credit Card, Debit Card',
  areaServed: {
    '@type': 'City',
    name: 'Montréal-Nord'
  }
};

export default function LocalBusinessJsonLd() {
  return <JsonLd data={localBusinessData} />;
}
